import { format_datetime } from './common';

/// formats the given value to a date format that is accepted/known by the api
export const format_as_api_accepted_date = (value: any): string | null => format_datetime(value, {
  format: 'YYYY-MM-DD',
});